// import _ from 'lodash';
import {URL_API_WEB_FORM_NAMES_INPUT, URL_API_MANAGEMENT_INVENTORY_API, URL_API_MANAGEMENT_SINGLE_INVENTORY_API} from '../apiHitFile'

export function ClidReportGenerate(obj, REPORT_URL){
  let headers = new Headers()
  headers.append('Content-Type','application/json');
  headers.append('Accept','application/json');
  return dispatch => {
    dispatch(resetReport())
    dispatch(ClidReportGeneratePending())    
    fetch(REPORT_URL, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(obj)
    }).then((res) => res.json())
      .then((json) =>{
        dispatch(ClidReportGenerateSuccess(json))    
        })
      .catch((error) =>{
        // dispatch(ClidReportGenerateSuccess(data)) 
         dispatch({ type:'REPORT_ACTION_ERROR', message:error.message,  showerror:true,
         isPending:false, reportData:[]})
      }) 
  } 
}
export function ClidReportGeneratePending(){
  return{
    type:'CLID_REPORT_ACTION_PENDING',
    isPending:true
  }
}

export function ClidReportGenerateSuccess(data){
  if((data.status === 200 || data.status=== 1001)){  
    return{
      type:'CLID_REPORT_ACTION_GENERATE',
      reportData:data,
      isPending:false
     }
    } else {
     return {
        type:'REPORT_ACTION_ERROR',
        message:data.message,
        showerror:true,
        isPending:false,
        reportData:[]
      }
    }
}

export function ClidReportDownload(obj, REPORT_URL, REPORTNAME){
    let headers = new Headers()
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    return dispatch => {
      dispatch(ClidReportGeneratePending())
      fetch(REPORT_URL, {
        method: 'POST',
        headers : headers,
        body:JSON.stringify(obj)
      }).then((response) => {
        if(response.status === 200){
        response.blob().then(function(myBlob) {
                window.URL = window.webkitURL || window.URL;
                var a = document.createElement('a');
                a.href = window.URL.createObjectURL(myBlob);
                a.download = REPORTNAME
                a.click();
        });
        dispatch({type:"CLID_REPORT_ACTION_PENDING", isPending:false})
        } else {
            dispatch({ type:'REPORT_ACTION_ERROR', message:"Something went Wrong",  showerror:true,
             isPending:false})
        }
        })
        .catch(error =>{ dispatch({ type:'REPORT_ACTION_ERROR', message:"Something went Wrong",  showerror:true,
        isPending:false})})
    } 
}

export function WebFormReportInput(obj){
  let headers = new Headers()
  headers.append('Content-Type','application/json');
  headers.append('Accept','application/json');
  return dispatch => {
    dispatch(ClidReportGeneratePending())
    fetch(URL_API_WEB_FORM_NAMES_INPUT, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(obj)
    }).then((res) => res.json())
      .then((json) =>{
        dispatch(WebFormReportInputSucess(json))    
        })
      .catch((error) =>{
       dispatch(WebFormReportInputSucess(error)) 
      //   dispatch({ type:'REPORT_ACTION_ERROR', message:error.message,  showerror:true,
      //   isPending:false, })
      }) 
  } 
}

export function WebFormReportInputSucess(data){
  if((data.status === 200 || data.status=== 1001) && data.value !== null){  
    return{
      type:'WEB_FORM_MAPPED_NAMES',
      webFormNames:data.value,
      isPending:false
    }
    } else {
      return{
        type:'REPORT_ACTION_ERROR',
        message:data.message,
        showerror:true,
        isPending:false,
      }
    }
}

export function ClientBasedOnInventory(){
  let headers = new Headers()
  headers.append('Content-Type','application/json');
  headers.append('Accept','application/json');
  return (dispatch, getState) => {
    let userName = getState().LoginReducer.loginAction.userName;
    let obj={userId:userName}
    dispatch(ClidReportGeneratePending())
    fetch(URL_API_MANAGEMENT_INVENTORY_API, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(obj)
    }).then((res) => res.json())
      .then((json) =>{
        dispatch(ClientBasedOnInventorySucess(json))    
        })
      .catch((error) =>{
      
        dispatch({ type:'REPORT_ACTION_ERROR', message:error.message,  showerror:true,
        isPending:false, })
      }) 
  } 
}

export function ClientBasedOnInventorySucess(data){
  if((data.status === 200 || data.status=== 1001)){  
    return{
      type:'CLIENT_BASED_VALUES',
      clientBasedValues:data.value,
      isPending:false
    }
    } else {
      return{
        type:'REPORT_ACTION_ERROR',
        message:data.message,
        showerror:true,
        isPending:false,
      }
    }
}

export function BasedOnInventory(){
  let headers = new Headers()
  headers.append('Content-Type','application/json');
  headers.append('Accept','application/json');
  return (dispatch, getState) => {
    let userName = getState().LoginReducer.loginAction.userName;
    let obj={userId:userName}
    dispatch(ClidReportGeneratePending())
    fetch(URL_API_MANAGEMENT_SINGLE_INVENTORY_API, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(obj)
    }).then((res) => res.json())
      .then((json) =>{
        dispatch(BasedOnInventorySucess(json))    
        })
      .catch((error) =>{
      
        dispatch({ type:'REPORT_ACTION_ERROR', message:error.message,  showerror:true,
        isPending:false, })
      }) 
  } 
}

export function BasedOnInventorySucess(data){
  if((data.status === 200 || data.status=== 1001)){  
    return{
      type:'PROCESS_BASED_VALUES',
      processBasedValue:data.value,
      isPending:false
    }
    } else {
      return{
        type:'REPORT_ACTION_ERROR',
        message:data.message,
        showerror:true,
        isPending:false,
      }
    }
}



export function ReportGenerateError(data){
    return{
      type:'REPORT_ACTION_ERROR',
      showerror:true,
      message:data.message,
      isPending:false
    }
}
export function resetReport(){
    return{
      type:'RESET_REPORT_ACTION',
      reportData:[]
    }
}

export function closeModalPopUp(){
  return{
    type:'REPORT_ACTION_MODAL_CLOSE',
    showerror:false
  }
}

